import { useTheme } from "@mui/material"
import { SxGeneral } from "../../../../../../../utils/types/generals"

type StyleKey = 'map'

export const useStyles = (): SxGeneral<StyleKey> => {
    const { palette } = useTheme()
    return {
        map: {
            minHeight: '500px',
            height: '100%',
            width: '100%',
            borderRadius: '10px',
            overflow: 'hidden',
            border: `1px solid ${palette.grey}55`,
        },
    }
}